export enum LeasingCalculatorPathsEnum {
  leasingCalculator = '/leasing-calculator',
  success = 'success',
}
